import { isNonNullable } from "@/types/isNonNullable";
import { isNullable } from "@/types/isNullable";
import classNames from "classnames";
import { ImageWithFallback } from "@/components/image/ImageWithFallback";
import type { FC } from "react";
import type { TeamLineupFormation } from "@motain/xpa-proto-files-web/lib/types/match_lineup";
import styles from "./MatchLineupFormation.module.scss";
import { Pitch } from "../pitch/Pitch";
import { trackingService } from "@/modules/analytics";
import { EventType } from "@motain/xpa-proto-files-web/lib/types/tracking";
import Link from "next/link";

export const MatchLineupFormation: FC<TeamLineupFormation> = (props) => {
  const { rows } = props;
  return (
    <div className={styles.container}>
      <Pitch />
      <ul className={styles.formation}>
        {rows.map((row) => {
          return (
            <li
              key={row.uiKey}
              className={styles.row}
              style={{ "--players-count": row.players.length }}
            >
              {isNonNullable(row) &&
                row.players.map((player) => {
                  if (isNullable(player.link) || isNullable(player.image)) {
                    return;
                  }

                  return (
                    <Link
                      key={player.uiKey}
                      href={player.link.urlPath}
                      title={player.name}
                      className={classNames("title-7-medium", styles.player)}
                      onClick={() => {
                        if (isNonNullable(player.link)) {
                          trackingService.sendXpaTracking(
                            player.link.trackingEvents,
                            EventType.EVENT_CLICK,
                          );
                        }
                      }}
                    >
                      <ImageWithFallback
                        className={styles.playerImage}
                        width={48}
                        height={48}
                        src={player.image.path}
                        alt={player.image.alt}
                        darkModeSrc={player.image.darkModePath}
                      />
                      <p className={styles.playerName}>
                        <span className={styles.playerNameText}>
                          {player.jerseyNumber}. {player.nickName}
                        </span>
                      </p>
                    </Link>
                  );
                })}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
